<template>
  <ModalNewDesign :title="selectedMenuComponent.label" @close="closeModal">
    <div class="nd-body">
      <div class="nd-inr">
        <div class="lt-wrap pd-all-3">
          <template v-for="(item, itemIndex) in items" :key="`item_${itemIndex}`">
            <button
              type="button"
              :class="['inr-gray-btn', item.value === selectedMenu ? 'on' : '']"
              @click="handleMenu(item.value)"
            >
              {{ item.label }}
            </button>
          </template>
        </div>
        <div v-if="selectedMenuComponent.component" class="nd-tab-con">
          <MobileTabsToggle v-if="isMobile" v-model="selectedMenu" />
          <component v-bind="selectedMenuComponent.componentProps" :is="selectedMenuComponent.component" />
        </div>
      </div>
    </div>
  </ModalNewDesign>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import SelfServiceCreditHistory from '@/components/domains/self-service/SelfServiceCreditHistory.vue';
import SelfServicePaymentHistory from '@/components/domains/self-service/SelfServicePaymentHistory.vue';
import MobileTabsToggle from '@/components/shared/composite/MobileTabsToggle.vue';
import ModalNewDesign from '@/components/shared/composite/ModalNewDesign.vue';
import { SelfServicePaymentMenu, SelfServiceSettingMenu } from '@/types/components';

const isMobile = ref(window.innerWidth <= 480);
const handleResize = () => {
  isMobile.value = window.innerWidth <= 480;
};

onMounted(() => {
  window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});

const props = withDefaults(
  defineProps<{
    menu: SelfServicePaymentMenu;
  }>(),
  {
    menu: 'PAYMENT',
  }
);
const emit = defineEmits<{ close: [] }>();

const { t } = useI18n();

const items = [
  {
    label: t('payment_history'),
    value: 'PAYMENT',
    component: SelfServicePaymentHistory,
    componentProps: {},
  },
  {
    label: t('credit_history'),
    value: 'CREDIT',
    component: SelfServiceCreditHistory,
    componentProps: {},
  },
] as const;

const selectedMenu = ref<SelfServiceSettingMenu>(props.menu);

const selectedMenuComponent = computed(() => {
  const component = items.find((item) => selectedMenu.value === item.value);
  return component || {};
});

const handleMenu = (menu: SelfServiceSettingMenu) => {
  selectedMenu.value = menu;
};

const closeModal = () => {
  emit('close');
};
</script>

<style scoped lang="scss">
.nd-tab-con {
  overflow: auto;
}
@include respond-to(mobile-portrait) {
  .nd-tab-con {
    :deep(.tit-h5) {
      display: none;
    }
  }
}
</style>
